<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品详情设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>商品详情设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="form_item">
            <div class="block">
              <p><span class="mark">*</span>设置商品简介</p>
              <div class="input_box">
                <el-input
                  v-model="formData.intro"
                  placeholder="请输入商品简介"
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>设置商品规格信息</p>
              <div class="textarea_box">
                <el-input
                  type="textarea"
                  v-model="formData.Specifications"
                  placeholder="请输入商品规格信息"
                  maxlength="500"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="form_item">
            <div class="block">
              <p>商品详情图片1</p>
              <p class="red">JPG或者PNG格式，尺寸比例为宽度750像素，高度不限</p>
              <div
                class="upload_box"
                @mouseenter="enter(1)"
                @mouseleave="creenIndex = ''"
                @click="clickUpload"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :disabled="true"
                >
                  <div v-if="formData.banner3">
                    <img :src="formData.banner3" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formData.img, 1)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="handleRemove(1)"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="block">
              <p>商品详情图片2</p>
              <p class="red">JPG或者PNG格式，尺寸比例为宽度750像素，高度不限</p>
              <div
                class="upload_box"
                @mouseenter="enter(1)"
                @mouseleave="creenIndex = ''"
                @click="clickUpload"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :disabled="true"
                >
                  <div v-if="formData.banner3">
                    <img :src="formData.banner3" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formData.img, 1)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="handleRemove(1)"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="block">
              <p>商品详情图片3</p>
              <p class="red">JPG或者PNG格式，尺寸比例为宽度750像素，高度不限</p>
              <div
                class="upload_box"
                @mouseenter="enter(1)"
                @mouseleave="creenIndex = ''"
                @click="clickUpload"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :disabled="true"
                >
                  <div v-if="formData.banner3">
                    <img :src="formData.banner3" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formData.img, 1)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="handleRemove(1)"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>设置商品详情信息</p>
            <div class="textarea_box">
              <el-input
                type="textarea"
                v-model="formData.details"
                placeholder="请输入商品详情信息"
                maxlength="500"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  uploadImage,
  editCommidity,
} from "../../../api/api";
export default {
  name: "cDetail",
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        intro: "", // 商品简介
        Specifications: "", // 商品规格描述
        details: "",
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.loading = true;
      let { id } = this.$route.params;
      getCommidityDetail({ id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.intro = res.intro ? res.intro : "";
        this.formData.Specifications = res.Specifications
          ? res.Specifications
          : "";
        this.formData.details = res.details ? res.details : "";
        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },

    // 图片上传
    clickUpload() {
      this.$message.warning("即将开放");
      return;
    },

    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.img = "";
      } else if (isType == 2) {
        this.formData.banner = "";
      } else if (isType == 3) {
        this.formData.banner2 = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url, type) {
      if (type == 1) {
        this.dialogImageUrl = url;
      }
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.img = res.url;
          } else if (creenIndex == 2) {
            this.formData.banner = res.url;
          } else if (creenIndex == 3) {
            this.formData.banner2 = res.url;
          } else if (creenIndex == 4) {
            this.formData.banner3 = res.url;
          } else if (creenIndex == 5) {
            this.formData.banner4 = res.url;
          } else if (creenIndex == 6) {
            this.formData.banner5 = res.url;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    query() {
      let { formData } = this;
      if (formData.intro == "") {
        this.$message.warning("请输入商品简介");
        return;
      }
      if (formData.Specifications == "") {
        this.$message.warning("请输入商品规格信息");
        return;
      }
      if (formData.details == "") {
        this.$message.warning("请输入商品详情信息");
        return;
      }
      this.loading = true;
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          // this.loading = false;
          // let message = this.$message.success(data.message);
          // setTimeout(() => {
          //   message.close();
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        .form_item {
          margin-bottom: 40px;
          .block {
            margin-bottom: 25px;
          }
        }
      }
    }
  }
}
</style>